import React from "react";
import {SafeAreaView, ScrollView, StyleSheet, View} from "react-native";
import {useDispatch, useSelector} from "react-redux";
import BalanceSelectButton from "../component/BalanceSelectButton";
import {useTheme} from "@react-navigation/native";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";

export const BalanceScreen = ({navigation, route}) => {
    const {task, callback} = route.params;
    const {t, i18n} = useTranslation();
    const balance = useSelector(state => state.balance);
    const dispatch = useDispatch();
    const isMobileWidth = useMediaQuery({
        maxDeviceWidth: 800
    });
    const theme = useTheme();

    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            backgroundColor: theme.colors.scheme[3],
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        list: {
            maxWidth: 800,
            display:'flex',
            flexDirection:'row',
            flexWrap:'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            padding:8
        }
    });
    return(
        <SafeAreaView style={styles.container}>
            <ScrollView>
                <View style={styles.list}>
                {
                    Object.keys(balance).map((prop, key) => {
                        return(<View key={key} style={{width:(isMobileWidth ? '100%':'50%'), padding:4}}><BalanceSelectButton id={balance[prop].id} color={balance[prop].color} title={balance[prop].title} task={task.id} /></View>)
                    })
                }
                </View>
            </ScrollView>
        </SafeAreaView>
    )
}